<template>
  <article class="motion president-motion-view">
    <!--
    <div style="max-height:100px;">
      <div v-resize-text>{{motion.name}}</div>
    </div>
    -->
    <header class="p-d-flex p-jc-center p-ai-center">
      <div class="flex-grow-1">
        <h1>{{motion.name}}</h1>
      </div>
      <div>
        <ontime-timer
          :url="ontimeUrl"
          :config="{
              onEnd: 'showNegative'
          }"
          />
        </div>
    </header>
    <header>
    </header>
    <!--<h2 v-if="motion.hasParent()">{{motion.parent.name}}</h2>-->
    <div class="p-grid p-pb-3">
      <div class="p-col">
        <div class="p-grid prop-sec p-mt-1">
          <div class="p-col">
            <p>Proposer</p>
            <div v-if="motion.hasProposer()">
              <strong>{{ proposer }}</strong>
              <speaker-state-display
                v-if="motion.proposerState && showSpeakerState"
                :state="motion.proposerState"/>
            </div>
            <div v-else class="empty-state">
              -
            </div>
          </div>
        </div>
      </div>
      <div class="p-col">
        <div class="p-grid prop-sec p-mt-1">
          <div class="p-col">
            <p>Seconder</p>
            <div v-if="motion.hasSeconder()">
              <strong>{{ seconder }}</strong>
              <speaker-state-display
                v-if="motion.seconderState && showSpeakerState"
                :state="motion.seconderState"/>
            </div>
            <div v-else class="empty-state">
              -
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-pb-3">
    <SelectButton v-model="mode" :options="[
      {
        value: 'single',
        label: 'Single Column'
      },
      {
        value: 'two',
        label: 'Two Columns'
      }
    ]" aria-labelledby="basic" optionValue="value" optionLabel="label" />
    </div>

    <div class="p-grid for-against">
      <div class="p-col">
        <speakers-table
          v-if="mode == 'single'"
          :speakers="motion.speakers"
          :show-state="showSpeakerState"
          :show-opinion="true"
          :combine-delegate-district="true"
          />
        <div v-else class="p-grid p-pb-3">
          <div class="p-col">
            <h4>For</h4>
            <speakers-table
              :speakers="motion.for"
              :show-state="showSpeakerState"
              :show-opinion="false"
              :combine-delegate-district="true"
              />
          </div>
          <div class="p-col">
            <h4>Against</h4>
            <speakers-table
              :speakers="motion.against"
              :show-state="showSpeakerState"
              :show-opinion="false"
              :combine-delegate-district="true"
              />
          </div>
        </div>

      </div>
    </div>
    <div v-if="motion.next != null">
      <h4>Next</h4>
      <h2 v-if="motion.next.name != null">{{ motion.next.name }}</h2>
      <div class="p-grid p-pb-3">
        <div class="p-col">
          <h4>Proposer</h4>
          <div v-if="motion.next.proposer != null">
            <span v-if="motion.next.proposer.name != null">{{ motion.proposer.name }}</span>
            <span v-if="motion.next.proposer.associationName != null">{{ motion.next.proposer.associationName }}</span>
          </div>
        </div>
        <div class="p-col">
          <h4>Seconder</h4>
          <div v-if="motion.next.seconder != null">
            <span v-if="motion.next.seconder.name != null">{{ motion.seconder.name }}</span>
            <span v-if="motion.next.seconder.associationName != null">{{ motion.next.seconder.associationName }}</span>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>
<script>
import OntimeTimer from '../ontime/OntimeTimer.vue'
import SpeakersTable from '../speakers/SpeakersTable.vue'
import SpeakerStateDisplay from '../speakers/SpeakerStateDisplay.vue'
import MotionStateDisplay from './MotionStateDisplay.vue'
import SelectButton from 'primevue/selectbutton/SelectButton'

export default {
  name: 'PresidentMotionView',
  components: {
    OntimeTimer,
    SpeakersTable,
    SpeakerStateDisplay,
    MotionStateDisplay,
    SelectButton
  },
  data: function () {
    return {
      mode: 'single'
    }
  },
  props: {
    motion: {
      type: Object,
      required: true
    },
    showSpeakerState: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ontimeUrl () {
      return this.$store.getters['settings/ontimeUrl']
    },
    proposer () {
      if (!this.motion.hasProposer()) {
        return null
      }
      var parts = []
      if (this.motion.proposer.getName() !== null && this.motion.proposer.getName().trim() !== '') {
        parts.push(this.motion.proposer.getName())
      }
      if (this.motion.proposer.associationName) {
        parts.push(this.motion.proposer.associationName)
      }
      if (parts.length) {
        return parts.join(', ')
      }
      return null
    },
    seconder () {
      if (!this.motion.hasSeconder()) {
        return null
      }
      var parts = []
      if (this.motion.seconder.getName() !== null && this.motion.seconder.getName().trim() !== '') {
        parts.push(this.motion.seconder.getName())
      }
      if (this.motion.seconder.associationName) {
        parts.push(this.motion.seconder.associationName)
      }
      if (parts.length) {
        return parts.join(', ')
      }
      return null
    },
    hasNext () {
      return this.motion && this.motion.next
    }
  }
}
</script>

<style scoped>
h1 {
  font-size: 2.5rem;
  margin-top: 0rem;
  margin-bottom: 0.5rem;
}
.motion-state {
  font-size: 1.5rem;
  font-weight: bold;
}
.prop-sec h4 {
  margin-top: 0;
}
.for-against h4 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}
.timer-display {
  font-size: 2rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/motions/PresidentMotionView.vue